module.exports = __webpack_public_path__ + "static/media/balconyCleaning.f29cf493.png";